import { Type } from '@angular/core';
import { EnumerationItem } from './enum-item.class';
import { WorkflowEnumeration } from './enum.class';
import { PrimitiveType, WorkflowEnum } from './workflow.type';

/**
 * Enum specific logic
 */
export class StaticEnumeration implements WorkflowEnumeration {
  /**
   * Array of enum values
   */
  public readonly values: EnumerationItem[] = [];

  /**
   * Get a unique Enumeration as a flat structure
   * @param id config id (as set in `workflow-enums.json`)
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(private readonly id: string, config: WorkflowEnum | PrimitiveType[], enumeration: Type<any>, gracefulFail?: boolean) {
    if (Array.isArray(config)) {
      for (const value of config) {
        this.values.push(new EnumerationItem(this.id, value));
      }
    } else if (config && typeof config === 'object') {
      if (typeof config.source === 'string') {
        const src = new enumeration(config.source);
        if (config.only) {
          for (const value of config.only) {
            const found = src.values.find((item) => item.value === value);
            if (found) {
              this.values.push(found);
            }
          }
        } else {
          this.values.push(...src.values.filter((item) => !config.sans || !config.sans.includes(item.value)));
        }
      }
      if (Array.isArray(config.virtual)) {
        for (const value of config.virtual) {
          this.values.push(new EnumerationItem(this.id, value));
        }
      }
      if (Array.isArray(config.order)) {
        config.order.forEach((value, index) => {
          const found = this.values.find((item) => item.value === value);
          const pos = found ? this.values.indexOf(found) : -1;
          if (pos > index) {
            this.values.splice(pos, 1);
            this.values.splice(index, 0, found);
          }
        });
      }
    } else if (!gracefulFail) {
      throw new Error(`Invalid enum "${id}"`);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public isSameEnum(instances: { [name: string]: any }): boolean {
    return !!instances[this.id];
  }
}
